import React, { Component } from 'react';
import { Modal, Table, Form, Input, Divider, message } from 'antd';
import axios from '../../service/index'
const { TextArea } = Input;

class menuManagement extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading:false,
			visible: false,
			lableListData: [],
			name: '',
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			labelName: '',
			essName:"",
			essDes:"",
			labelperms:"",
			labelId: null,
			menuId: null,
			modelTitle: '新建菜单',
			classShow:false,
			esshow:false,
			pidName:"",
			pid:"",
			columns: [
        {
					title: 'ID',
					dataIndex: 'id',
					key: 'id',
					align: 'left'
				},
				{
					title: '内容',
					dataIndex: 'content',
					key: 'content',
					align: 'center'
				},
				{
					title: '描述',
					dataIndex: 'des',
					key: 'des',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					render: (record) => <div>
            {record.lev === 1 ?
            <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								visible: true,
								esshow: true,
								essName: record.content,
								essDes: record.des,
								labelperms: record.perms,
								modelTitle: '添加模块',
								labelId: record.id,
								classShow: false,
							})
						}}>添加</span> : ''}
						<span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							this.setState({
								visible: true,
								esshow: true,
								essName: record.content,
								essDes: record.des,
								labelperms: record.perms,
								modelTitle: '编辑模块',
								labelId: record.id,
								classShow: false,
							})
						}}>编辑</span>
					</div>
				},
			]
		}
	}

	componentDidMount() {
		this.lableList()
	}
	componentWillUnmount() {
		this.setState = () => false;
 }
  //获取用户菜单
	lableList(page) {
		this.setState({
			loading:true
		})
		
		if(page){
			this.setState({searchData: page})
		}
		axios.get('/dictionaryController/getDictionaryList',{
			...this.state.searchData,
			name: this.state.name
		}).then(res => {
      
			if (res.data.code === '200') {
        
				let arrdata = res.data.data
				// arrdata.map(item =>{
				// 	item.child = item.children
				// 	delete item.children
				// 	return item
				// })
				this.setState({
          lableListData: arrdata,
					total: arrdata.length,
					loading:false
				})
				
			}
		})
	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
      if(this.state.modelTitle === '编辑模块'){
					axios.post('dictionaryController/updateDictionaryById',{
            content: values.content,
						id:this.state.labelId,
					}).then(res=> {
						if(res.data.code === '200'){
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				}else if(this.state.modelTitle === '编辑菜单'){
					axios.post('dictionaryController/updateDictionaryById',{
						id:this.state.menuId,
						content: values.content,
					}).then(res=> {
						if(res.data.code === '200'){
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
				} else if (this.state.modelTitle === '添加模块') {
          axios.post('dictionaryController/addDictionaryByPid',{
            content: values.content,
            des: values.des,
						pid:this.state.labelId,
					}).then(res=> {
						if(res.data.code === '200'){
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						}else {
							message.error(res.data.msg)
						}
					})
        }
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	onExpand = (expanded,record) => {
		this.setState({
			pid:record.id,
			pidName:record.title
		})
	}


	render() {
		const { lableListData, modelTitle, columns, visible, labelName,labelperms, total,classShow ,essDes,esshow,essName,loading} = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination ={
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal:() => `共 ${total} 条`,
			onShowSizeChange: (current,pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>系统设置</span>
				<Divider />
				<Table 
						loading={loading} dataSource={lableListData} columns={columns} rowKey={record => record.id} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')} 
						pagination={pagination} 
					  onExpand={(expanded,record)=>this.onExpand(expanded,record)} />
        {/* expandedRowRender={record => this.expandedRowRender(record)} */}
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
					
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleOk}>
					{esshow&&<Form.Item label={"内容"}>
							{getFieldDecorator('content', {
								rules: [{ required: true, message: '请输入内容!'}],
								initialValue:modelTitle==='编辑模块'? essName: ''
							})(
								<TextArea  placeholder='请输入内容' autoSize />
							)}
						</Form.Item>}
						{classShow&&<Form.Item label={"内容"}>
							{getFieldDecorator('content', {
								rules: [{ required: true, message: '请输入内容!'}],
								initialValue:modelTitle==='编辑菜单'? labelName: ''
							})(
								<TextArea  placeholder='请输入内容' autoSize />
							)}
						</Form.Item>}
						{classShow&&<Form.Item label={"描述"}>
							{getFieldDecorator('des', {
								rules: [{ required: false, message: '请输入描述!'}],
								initialValue:modelTitle==='编辑菜单'? labelperms: ''
							})(
								<Input disabled placeholder='请输入Class' />
							)}
						</Form.Item>}
						{esshow&&<Form.Item label={"描述"}>
							{getFieldDecorator('des', {
								rules: [{ required: true, message: '请输入url!'}],
								initialValue:modelTitle==='编辑模块'? essDes: ''
							})(
								<Input disabled={modelTitle === '添加模块' ? false : true} placeholder='请输入路径url' />
							)}
						</Form.Item>}
					</Form>
				</Modal>
			</div>
		)
	}
};

export default Form.create()(menuManagement)
